import { VerificationNames } from "shared/types";
import { toMoney } from "utils/currency";
import { Verification } from "./types";
import { toFixedFloored } from "utils/toFixedFloored";

export const verificationNameToTitle = (name: VerificationNames) => {
  switch (name) {
    case VerificationNames.CreditReport:
      return "Credit report";
    case VerificationNames.EvictionReport:
      return "Housing court report";
    case VerificationNames.HousingHistory:
      return "Housing history";
    case VerificationNames.RentalApplication:
      return "Rental application";
    case VerificationNames.IncomeVerification:
      return "Self-reported income history";
    case VerificationNames.VerifiedIncomeVerification:
      return "Verified income history";
    case VerificationNames.IdentityVerification:
      return "Identity verification";
    case VerificationNames.CriminalReport:
      return "Criminal report";
    default:
      return "";
  }
};

export const toMoneyIfExist = (cents: number | undefined | null) => {
  if (cents === undefined || cents === null) return "-";
  return toMoney(cents / 100);
};

export const sortVerifications = function sortArray<T>(
  arr: T[],
  order: string[]
): T[] {
  return arr.sort((a, b) => {
    const aValue = order.indexOf((a as Verification).name);
    const bValue = order.indexOf((b as Verification).name);

    // If aValue or bValue is -1 (not found in order array), it should be placed at the end.
    const aPos = aValue === -1 ? order.length : aValue;
    const bPos = bValue === -1 ? order.length : bValue;

    return aPos - bPos;
  });
};

export const calculatePastDueAccounts = (summary: Verification["summary"]) => {
  const pastDueAccounts = summary?.past_due_accounts;

  if (pastDueAccounts === "No data") return "No data";

  if (summary?.past_due_accounts_type === "Percentage") {
    const { total_accounts } = summary;

    if (
      !total_accounts ||
      total_accounts === 0 ||
      !pastDueAccounts ||
      pastDueAccounts === 0
    )
      return "-";

    return `${toFixedFloored((pastDueAccounts / total_accounts) * 100, 2)}%`;
  }

  return pastDueAccounts ?? "-";
};
